module.exports = __webpack_public_path__ + "static/1686341904-Blank2000x13332-30768b5a48127fad5e4c3fe587a40880.webp";